import React from 'react';
import PropTypes from 'prop-types';

import { Stack, Chip } from '@metarouter-private/mr-mui';

import usePrimaryClusterIndicatorConfig from './usePrimaryClusterIndicatorConfig';

export default function PrimaryClusterIndicator({ clusterId }) {
  const { shouldShow, visibility, chipProps } = usePrimaryClusterIndicatorConfig({ clusterId });

  if (!shouldShow) {
    return null;
  }

  return (
    <Stack direction="row" visibility={visibility} justifyContent="flex-end">
      <Chip {...chipProps} />
    </Stack>
  );
}

PrimaryClusterIndicator.propTypes = {
  clusterId: PropTypes.string.isRequired,
};
